// todo: handle missing window.localStorage
const _storage = window.localStorage

// notes:
// localstorage stores null as "null"(string)
export default {

  get (key) {
    const v = _storage.getItem(key)
    try {
      return JSON.parse(v) || v
    } catch (e) { return v }
  },

  set (key, value) {
    _storage.setItem(key, JSON.stringify(value))
  },

  has (key) {
    let v = this.get(key)
    return v !== null && v !== 'null' && v !== undefined
  },

  remove (key) {
    _storage.removeItem(key)
  }
}



// WEBPACK FOOTER //
// ./src/services/storage.js